<template>
    <el-collapse-item :name="index">
        <!-- 标题（全选/公司/分行名） -->
        <template #title>
            <el-checkbox
                v-model="check_all"
                :indeterminate="is_indeterminate"
                @change="handleCheckAll">
                <span class="member_form_checkbox_title" v-if="itemDetail.branchname">{{itemDetail.branchname}}</span>
                <span class="member_form_checkbox_title" v-else>{{itemDetail.companyname}}</span>
            </el-checkbox>
        </template>
        <!-- 选项（部门） -->
        <el-checkbox-group
            v-model="check_list"
            class="member_form_checkbox_group"
            @change="handleCheckItem">
            <div v-if="itemDetail.department.length==0">
                {{$t('message.cmember.form21')}}
            </div>
            <el-checkbox
                v-for="(item,i) in itemDetail.department"
                :key="i"
                :label="item.department_id">
                {{item.departmentname}}
            </el-checkbox>
        </el-checkbox-group>
    </el-collapse-item>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
    data() {
        return {
            check_all: false, // 全选框是否全选状态
            is_indeterminate: false, // 全选框不确定状态
            check_list: [],
        }
    },
    props: {
        "itemDetail": Object, // 分公司对象
        "index": Number, // 当前折叠面板下标，用于手风琴效果
        "isAdd": Boolean, // 引用组件是否为添加
        "countCheck": Function // 用于计算是否勾选全部子公司
    },
    computed: mapState({
        select_jurisdiction: state => state.user.select_jurisdiction,
    }),
    methods: {
        ...mapMutations([
            "setSelectJurisdiction"
        ]),
        handleCheckAll(val){ // 全选框绑定值更改事件
            let data = [];
            this.itemDetail.department.find((item, index, arr) => {
                data.push(item.department_id);
            })
            this.check_list = val ? data : [];
            this.is_indeterminate = false;
        },
        handleCheckItem(val){
            let checkedCount = val.length;
            this.check_all = checkedCount === this.itemDetail.department.length;
            this.is_indeterminate = checkedCount > 0 && checkedCount < this.itemDetail.department.length;
        }
    },
    created() {
        let select_arr = this.select_jurisdiction[this.itemDetail.branch_id],
        source_arr = this.itemDetail.department,
        new_arr = [];
        if(!this.isAdd && select_arr){
            select_arr.find((item, index, arr) => {
                if(item.department_id !== 0){
                    new_arr.push(item.department_id)
                }else if(item.department_id === 0){
                    this.check_all = true;
                }
            })
            this.check_list = new_arr;
            this.handleCheckItem(new_arr);
        }
    },
    watch: {
        check_all(val){
            if(this.is_indeterminate == true) return; // 不确定状态下，不触发

            let id = this.itemDetail.branch_id, data = [], is_del = false;
            if(val){ // 全选状态
                if(this.check_list.length === 0){
                    data = [{
                        branch_id: id,
                        department_id: ""
                    }]
                }else{
                    this.check_list.find((item, index, arr) => {
                        data.push({
                            branch_id: id,
                            department_id: item
                        })
                    })
                }
            }else if(this.is_indeterminate == false){ // 非全选、非不确定状态
                is_del = true;
            }
            this.setSelectJurisdiction({
                id,
                data,
                is_del
            })
            this.countCheck(val? "+": "-");
        },
        check_list(val){
            if(this.itemDetail.department.length == 0) return; // 无部门

            let id = this.itemDetail.branch_id, data = [], is_del = false;
            if(val.length > 0){
                val.find((item, index, arr) => {
                    data.push({
                        branch_id: id,
                        department_id: item
                    })
                }) 
            }else{
                is_del = true;
            }
            this.setSelectJurisdiction({
                id: this.itemDetail.branch_id,
                data,
                is_del
            })
        },
    },
}
</script>

<style scoped>
/* 多选框 */
.member_form_checkbox_group>.el-checkbox+.el-checkbox{
    margin-left: 0;
}
.member_form_checkbox_title{
    font-size: 16px;
    font-weight: bold;
}
</style>